import FGInput from "../dumb/FGInput";
import { Modal } from "react-bootstrap";
import FGTextarea from "../dumb/FGTextarea";
import { WLField } from "../dumb/WLFieldsEditor";
import Notifier from "../../modules/notifier/notifier";
import { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import FGDropdown from "../dumb/FGDropdown";
import FGDropdownApi from "../form/FGDropdownApi";
import AriaHelper, { DEFAULT_WORD_LIMIT, DEFAULT_WORD_LIMIT_OPTIONS } from "../../modules/aria-helper";

export type TPopupWLFieldEditorRef = {
  show: () => void;
  hide: () => void;
  setEdit: (state: boolean) => void;
};

type TPopupWLFieldEditorProps = {
  value?: WLField;
  onHide?: () => void;
  onSave?: (value: WLField) => void;
};

const PopupWLFieldEditor = forwardRef<
  TPopupWLFieldEditorRef,
  TPopupWLFieldEditorProps
>((props, ref) => {
  const [show, setShow] = useState(false);
  const [value, setValue] = useState<WLField>({
    name: "",
    description: "",
    max_word: DEFAULT_WORD_LIMIT,
    _id: null,
  });
  const [edit, setEdit] = useState(false);

  useImperativeHandle(ref, () => ({
    show() {
      setShow(true);
    },
    hide() {
      setShow(false);
    },
    setEdit(state: boolean) {
      setEdit(state);
    },
  }));

  useEffect(() => {
    if (!show) {
      setTimeout(() => setEdit(false), 350);
    }
  }, [show]);

  const onShow = () => {
    if (!props.value) return;

    setValue(props.value);
  };

  const onHide = () => {
    setShow(false);
    props.onHide && props.onHide();
    setTimeout(() => setValue({ name: "", description: "", _id: null, max_word: DEFAULT_WORD_LIMIT }), 50);
  };

  const onChange = (e: any) => {
    setValue((_) => ({ ..._, [e.target.name]: e.target.value }));
  };

  const save = () => {
    let field = value;
    field.name = field.name?.trim();
    if (!field.name) {
      Notifier.error("Title is required");
      return;
    }
    props.onSave && props.onSave(field);
    onHide();
  };

  return (
    <Modal
      size="lg"
      className="modal-generic modal-wl-field-editor"
      show={show}
      onShow={onShow}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{edit ? "Edit Section" : "New Section"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FGInput
          required
          id="name"
          name="name"
          label="Title"
          autoFocus
          value={value.name}
          onChange={onChange}
        ></FGInput>
        <FGTextarea
          id="description"
          name="description"
          label="Description (up to 200 characters)"
          value={value.description}
          onChange={onChange}
          maxLength={200}
          showMaxLength
        />
        <FGDropdownApi
          id="max_word"
          name="max_word"
          label={"Maximum number of words allowed"}
          options={DEFAULT_WORD_LIMIT_OPTIONS}
          defaultValue={AriaHelper.parseWordLimit(value?.max_word) + ""}
          value={AriaHelper.parseWordLimit(value?.max_word) + ""}
          onChange={(e) => {
            onChange(e);
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-mw btn-secondary" onClick={save}>
          Save
        </button>{" "}
        <button className="btn btn-mw btn-primary" onClick={onHide}>
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
});

export default PopupWLFieldEditor;
